import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import Footer from '../../components/layout/Footer';
import { Mail, Shield, Lock } from 'lucide-react';

const CanalEtico = () => {
  const { language } = useLanguage();

  return (
    <div className="min-h-screen relative bg-[#1a2a3a]">
      <div className="relative z-10 max-w-4xl mx-auto px-6 pt-32 pb-24">
        <h1 className="text-white text-4xl font-light mb-12">Canal Ético</h1>
        
        <div className="prose prose-invert prose-lg max-w-none text-white/80">
          <p className="lead">
            <strong>Inversión en Activos Bancarios PK, S.L. – OKUANT</strong> pone a disposición de empleados, colaboradores, proveedores y terceros este Canal Ético para comunicar cualquier irregularidad o conducta contraria a la ética empresarial y a la normativa vigente.
          </p>

          <div className="grid md:grid-cols-3 gap-6 my-12">
            <div className="bg-white/5 p-6 rounded-lg text-center">
              <Shield className="text-[#3eb8b3] mx-auto mb-4" size={48} strokeWidth={1} />
              <h3 className="text-white text-lg mb-2">Confidencialidad</h3>
              <p className="text-sm">Garantizamos la confidencialidad de todas las comunicaciones recibidas</p>
            </div>
            <div className="bg-white/5 p-6 rounded-lg text-center">
              <Lock className="text-[#3eb8b3] mx-auto mb-4" size={48} strokeWidth={1} />
              <h3 className="text-white text-lg mb-2">Protección</h3>
              <p className="text-sm">Protegemos la identidad del denunciante frente a posibles represalias</p>
            </div>
            <div className="bg-white/5 p-6 rounded-lg text-center">
              <Mail className="text-[#3eb8b3] mx-auto mb-4" size={48} strokeWidth={1} />
              <h3 className="text-white text-lg mb-2">Respuesta</h3>
              <p className="text-sm">Nos comprometemos a dar respuesta en un plazo razonable</p>
            </div>
          </div>

          <h2 className="text-[#3eb8b3] text-2xl mt-10 mb-4">¿Qué se puede comunicar?</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>Incumplimientos del Código de Conducta</li>
            <li>Irregularidades contables o financieras</li>
            <li>Actos de corrupción o soborno</li>
            <li>Conflictos de interés</li>
            <li>Incumplimientos normativos</li>
            <li>Conductas contrarias a los derechos fundamentales</li>
          </ul>

          <h2 className="text-[#3eb8b3] text-2xl mt-10 mb-4">Acceder al Canal Ético</h2>
          <p>Para realizar cualquier comunicación a través del Canal Ético, puede hacerlo de forma anónima y confidencial a través del siguiente enlace o escaneando el código QR:</p>

          <div className="bg-[#3eb8b3]/10 p-8 rounded-lg mt-6 border border-[#3eb8b3]/30 flex flex-col sm:flex-row items-center gap-8">
            <div className="flex flex-col items-center gap-4">
              <img src="/qretico.png" alt="QR Canal Ético" className="w-40 rounded-lg bg-white p-2 object-contain aspect-square" />
              <span className="text-white/50 text-xs">Escanea el QR</span>
            </div>
            <div className="flex flex-col items-center gap-4">
              <p className="text-white/80 text-center">
                Acceda al formulario del Canal Ético para tramitar su información, consulta o denuncia de forma segura.
              </p>
              <a
                href="https://okuant.complylaw-canaletico.es/public/73d502773913fccfc0514507412ad127/formulario"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block text-[#3eb8b3] border border-[#3eb8b3] px-6 py-3 text-sm tracking-widest hover:bg-[#3eb8b3] hover:text-white transition-all duration-300 uppercase"
              >
                Acceder al Canal Ético
              </a>
            </div>
          </div>

          <h2 className="text-[#3eb8b3] text-2xl mt-10 mb-4">Contacto</h2>
          <div className="bg-white/5 p-6 rounded-lg mt-4">
            <p className="text-white text-lg">
              <strong>Email:</strong> <a href="mailto:privacidad@okuant.com" className="text-[#3eb8b3] hover:underline">privacidad@okuant.com</a>
            </p>
            <p className="text-white text-lg mt-2">
              <strong>Dirección:</strong> C/ Claudio Coello, 33, 1º A - 28001 Madrid
            </p>
          </div>

          <p className="mt-8 text-sm text-white/60">
            Todas las comunicaciones serán tratadas conforme a lo establecido en nuestra Política de Privacidad y la normativa vigente en materia de protección de datos.
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default CanalEtico;
